import { FirebaseError } from '@angular/fire/app';

export interface CustomCfError {
  error: { message: string; status: string };
}

export function extractErrorMessage(error: FirebaseError): CustomCfError | null {
  const jsonMatch = error.message.match(/{.*}/);
  if (jsonMatch) {
    try {
      const parsedJson = JSON.parse(jsonMatch[0]);
      return parsedJson;
    } catch {
      return null;
    }
  }

  return null;
}
